
<template>
    <div class="mb-5">
        <div>
            <!-- <v-btn v-if="fetchMsg==''" flat color="primary" @click="fetchTransactions">Retrieve transactions</v-btn> -->
            <v-btn flat color="primary" @click="refresh">Refresh</v-btn> 
            <v-btn flat  @click="addCustomTransaction">Create transaction</v-btn> 
            <span class="ma-1 caption right">Total amount: {{totalAmount}}</span>
                        
            <div class="m-2">{{fetchMsg}}</div>            
        </div>
        <div v-for="account in accounts" :key="account">
            <div class="account ml-2 mt-4">{{account}}</div>
            <template v-for="transaction in transactions(account)">
                <transaction-card :value="transaction" :ruleMatchExecuted="ruleMatchExecuted" :key="transaction.key" @save="save(transaction)" />                       
            </template>
        </div>        
        <gat-bottom-panel>
            <span class="paddingBlock"></span>
             <v-btn @click="applyRulesToTransactions">Run rules</v-btn>
            <v-btn @click="saveAll" color="primary">Save all</v-btn>
        </gat-bottom-panel>
    </div>
</template>

<script>
    import TransactionCard from '@/components/TransactionCard.vue'
    import GatBottomPanel from '@/GatComponents/GatBottomPanel.vue'
    import {apiPost} from '@/dal.js';
import numeral from 'numeral';
    var moment = require('moment');
    export default {
        name: 'NewTransactions',
        props: [],
        components: {TransactionCard,GatBottomPanel},
        data: function() {
            return	{
                fetchMsg : "",
                ruleMatchExecuted : false,
            }
        },

        computed:{
            accounts(){
                let result = [];
                this.$store.state.newTransactions.forEach(trans => {
                    if(!result.includes(trans.TRA_ACCOUNT)){
                        result.push(trans.TRA_ACCOUNT);
                    }
                });
                return result;
            },
            lastImportTime(){
                return  moment(this.$store.state.lastImport).format("YYYY-MM-DD HH:mm");
            },
            totalAmount(){
                //sum of all transactions
                let total = 0;
                this.$store.state.newTransactions.forEach(item=>{
                    total += item.TRA_AMOUNT;
                });
                return numeral(total).format('0,0.00');
                
                
            }   
        },

        created(){
          
        },

        watch:{
        },

        mounted(){
            if(this.$store.state.expectedTransactions.length==0){
                this.$store.dispatch('getExpectedTransactions');
            }
        },

        methods:{
            addCustomTransaction(){
                let trans = {"TRA_ID":null,"TRA_DATE":new Date(), TRA_ACCOUNT:"Virtual", TRA_AMOUNT:0, TRA_TYPE : 'Manual'};
                this.$store.state.newTransactions.push(trans);

            },

            fetchTransactions(){
                this.fetchMsg = "retrieving bank transactions (may take a while)";
                  apiPost('cmd/import-new-transactions').then(result=>{
                      
                      this.$store.dispatch('getNewTransactions');
                      this.fetchMsg = result;
                }) ;
            },

            refresh(){
                this.$store.dispatch('getNewTransactions');
            },

             transactions(accountName){
                return this.$store.state.newTransactions.filter(item=>{
                    return item.TRA_ACCOUNT == accountName;
                });
            },

            ruleMatch(transacation,rule){
                let result = true;
                //text match only
                if(rule.RULE_MATCH_TEXT){
                    result = result && transacation.TRA_TEXT.toLowerCase().includes(rule.RULE_MATCH_TEXT.toLowerCase());
                }
                if(rule.RULE_MATCH_TYPE){
                    result = result && transacation.TRA_TYPE.toLowerCase().includes(rule.RULE_MATCH_TYPE.toLowerCase());
                }
                if(rule.RULE_MATCH_ACCOUNT){
                    result = result && transacation.TRA_ACCOUNT.toLowerCase().includes(rule.RULE_MATCH_ACCOUNT.toLowerCase());
                }
                if(rule.RULE_MATCH_AMOUNT != null){                  
                    result = result && transacation.TRA_AMOUNT === rule.RULE_MATCH_AMOUNT;
                }


                return result;
            },

            saveAll(){
                this.$store.state.newTransactions.map(trans=>{
                    if(trans.TRA_CAT_ID){
                        this.save(trans);
                    }
                })
            },

            save(transaction){
                if(transaction.TRA_TYPE == 'Manual'){    
                    this.$store.commit('removeNewTransaction',transaction);            
                } else{                
                    apiPost('/db/transaction',transaction).then(result=>{
                        if(result.code == 200){                         
                            this.$store.commit('removeNewTransaction',transaction);
                        }
                    }) ;
                }
            },

            applyRule(transaction){
                 this.$store.state.rules.map(rule=>{
                   if(this.ruleMatch(transaction,rule)){
                       let e = JSON.stringify(transaction);
                       e = JSON.parse(e);
                       e.TRA_CAT_ID = rule.RULE_CAT_ID;
                       e.rule = rule;
                       this.$store.commit("updateNewTransaction",e);
                   }
                });
            },

            applyRulesToTransactions(){
                this.$store.state.newTransactions.map(transaction=>{
                    this.applyRule(transaction);
                });
                this.ruleMatchExecuted = true;
            }
        },
    }
</script>

<style scoped>
    .account{
        font-size: 1.3em;
        font-weight: bold;
        text-transform: uppercase;
        opacity: 0.7;
    }

    .paddingBlock{
        padding-right: var(--gatDrawerWitdth);
    }
</style>
